import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import zh from "./locales/zh.json";
import hi from "./locales/hi.json";
import ar from "./locales/ar.json";

export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇦🇺" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
];
const CODES = LANGUAGES.map((l) => l.code);

i18next.use(LanguageDetector).init({
  resources: { en: { translation: en }, es: { translation: es }, fr: { translation: fr }, zh: { translation: zh }, hi: { translation: hi }, ar: { translation: ar } },
  fallbackLng: "en",
  supportedLngs: CODES,
  nonExplicitSupportedLngs: true,
  load: "languageOnly",
  initImmediate: false,
  interpolation: { escapeValue: false },
  detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "i18nextLng" },
});

export const currentLang = () => (i18next.resolvedLanguage || "en").split("-")[0];
export const t = (key, opts) => i18next.t(key, opts);
// Legal pages can be forced to English (the binding version) without changing the site language.
export const legalT = (forceEn) => (forceEn ? i18next.getFixedT("en") : t);

const apply = () => {
  const lang = currentLang();
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
};
apply();

// Module-level t() is evaluated once per load, so switching language reloads the page for consistency.
export const setLanguage = (code) => {
  if (!CODES.includes(code) || code === currentLang()) return;
  localStorage.setItem("i18nextLng", code);
  window.location.reload();
};

export default i18next;
